import { IFeeData, ISettlementItemData } from 'types/order/fees/ISectionData';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { IStandardDocumentVersionData } from '../../../types/order/documents/shared/interfaces';

export interface ILineItem {
  id: string;
  fees?: IFeeData[];
  disbursementIds: string[][];
  documents?: IStandardDocumentVersionData[];
  feePayees?: string[];
  stringSettlementStatementPropertyValues: { [key: string]: string };
  numericSettlementStatementPropertyValues: { [key: string]: number };
}

const reduceToTruthy = <T extends string | number>(
  p: { [key: string]: T },
  c: { [key: string]: T }
): { [key: string]: T } => {
  const result = {} as { [key: string]: T };
  Object.keys(c).forEach(
    (key) =>
      (result[key] = ['FALSE', 'false'].includes((p[key] ?? '').toString()) ? c[key] ?? p[key] : p[key] || c[key])
  );
  return {
    ...p,
    ...result,
  };
};

export const convertSettlementItemToLineItem = (
  {
    settlementStatementItemId,
    statementFees,
    stringSettlementStatementPropertyValues,
    numericSettlementStatementPropertyValues,
  }: ISettlementItemData,
  adminDocuments: IStandardDocumentVersionData[] = []
): ILineItem => {
  const allLinkedDocumentIds = statementFees.flatMap((fee) => fee.linkedDocumentIds);
  const lineItem = {
    id: settlementStatementItemId,
    fees: statementFees,
    disbursementIds: statementFees.map((fee) => fee.disbursementIds),
    documents: adminDocuments.filter((document) => allLinkedDocumentIds.includes(document.id)),
    feePayees: statementFees
      .map((fee) => fee.stringFeePropertyValues[eFeePropertyNames.Payee])
      .filter((payee) => !!payee),
    dateFrom: statementFees.find((fee) => fee.stringFeePropertyValues[eFeePropertyNames.DateFrom])
      ?.stringFeePropertyValues[eFeePropertyNames.DateFrom],
    dateTo: statementFees.find((fee) => fee.stringFeePropertyValues[eFeePropertyNames.DateTo])?.stringFeePropertyValues[
      eFeePropertyNames.DateTo
    ],
    goodThruDate: statementFees.find((fee) => fee.stringFeePropertyValues[eFeePropertyNames.GoodThruDate])
      ?.stringFeePropertyValues[eFeePropertyNames.GoodThruDate],
    stringSettlementStatementPropertyValues,
    numericSettlementStatementPropertyValues,
  };
  lineItem.stringSettlementStatementPropertyValues = {
    ...statementFees
      .map((t) => t.stringFeePropertyValues)
      .reduce(reduceToTruthy, lineItem.stringSettlementStatementPropertyValues),
  };
  lineItem.numericSettlementStatementPropertyValues = {
    ...statementFees
      .map((t) => t.numericFeePropertyValues)
      .reduce(reduceToTruthy, lineItem.numericSettlementStatementPropertyValues),
  };
  return lineItem;
};
